import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Wish1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M12.964 4c.776 0 1.52.31 2.063.857a2.914 2.914 0 0 1 .145 3.977l-.144.154-5.41 5.4a.6.6 0 0 1-.762.071l-.083-.068-5.412-5.322a2.923 2.923 0 0 1 .001-4.142c1.096-1.086 2.836-1.13 4.01-.102l.144.134.555.636.17.2a.6.6 0 0 1-.837.853l-.077-.076-.165-.194-.52-.599a1.73 1.73 0 0 0-2.435 0 1.72 1.72 0 0 0-.117 2.31l.115.126 4.986 4.903 4.99-4.98c.284-.282.459-.651.498-1.045l.008-.17c0-.456-.182-.893-.509-1.217a1.71 1.71 0 0 0-2.305-.112l-.127.116L8.9 8.527a.611.611 0 0 0 .435 1.045c.13 0 .256-.042.363-.12l.076-.066 2.08-2.05a.599.599 0 0 1 .912.772l-.07.083-2.075 2.044a1.81 1.81 0 0 1-2.571.002 1.81 1.81 0 0 1-.108-2.438l.111-.122 2.846-2.816A2.9 2.9 0 0 1 12.964 4"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Wish1$1 = Svg18Wish1;

export { Svg18Wish1$1 as default };
